export default __webpack_public_path__ + "static/media/sign-in-background.7f9ed0fb.jpg";